const initialAssignmentsFilterState = {
  fetching: false,
  fetched: false,
  items: [],
  error: null,
  nbResult: 0,
  filterDay: null
};

export const getRecapByDayReducer = (state = initialAssignmentsFilterState, action) => {
  switch (action.type) {
    case "GET_RECAP_BY_DAY_PENDING": {
      return {...state, fetched: false, fetching: true};
    }
    case "GET_RECAP_BY_DAY_FULFILLED": {
      const {data, nbResult} = action.payload.data;
      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        items: data ? data : [],
        nbResult: nbResult
      };
    }

    case "GET_RECAP_BY_DAY_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
      }
      return {
        ...state,
        fetching: false,
        items: [],
        nbResult: 0,
        error
      };
    }

    case "SET_FILTER_INVOICES_DAY": {
      return {...state, filterDay: action.payload};
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./app/reducers/index/statistics/getRecapByDay.js